// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box, Grid2, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
import { BaseLabel } from '~/components/common';
// Others
import { EMPTY_VALUE } from '~/utils/constants/common';
import { useAppSelector } from '~/utils/redux/hooks';
// Styles, images, icons
import styles from './AdditionalInformation.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const AdditionalInformation = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/vendors', 'common/base']);
  const { detailVendor } = useAppSelector((state) => state.vendor);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const renderValueItem = (label: string, value: string) => {
    return (
      <Stack gap={1}>
        <Typography className={cx('label')}>{label}</Typography>
        <Typography className={cx('value')}>{value}</Typography>
      </Stack>
    );
  };
  //#endregion Handle Function

  return (
    <Box id='additionalInformationComponent' className={cx('container')}>
      <BaseLabel styleType='title' label={t('vendor_detail_additional_information_title')} />

      <Grid2 container rowSpacing={4} columnSpacing={2}>
        <Grid2 size={12}>
          {renderValueItem(t('vendor_detail_vendor_type_label'), detailVendor?.type || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={12}>
          {renderValueItem(t('vendor_detail_website_label'), detailVendor?.website || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={12}>
          {renderValueItem(t('vendor_detail_description_label'), detailVendor?.description || EMPTY_VALUE)}
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default AdditionalInformation;
